<script>
export default {
    data(){
        return {
            user_roles:[],
            allow:false
        }
    },
    methods:{
        $is(current_user){
            const current_role = (typeof this.currentRole == 'object' ? this.currentRole : JSON.parse(this.currentRole));
            const role = current_role.some(r=>current_user.includes(r));
            if(current_role.includes('author')){
                return true;
            }else{
                return role;
            }
        }
    },
    computed:{
        currentRole(){
            return this.$store.getters['auth/roles'] || []
        }
    }
}
</script>
